import IconRollerSkip from '~/components/icon/IconRollerSkip.vue';
import IconSmallSkip from '~/components/icon/IconSmallSkip.vue';

export default {
    computed: {
        skipSizes() {
            return [
                {
                    name: this.services.sizes['2yd'],
                    slug: '2yd',
                    text: this.$t('jobs.service_description.2yd'),
                    icon: IconSmallSkip,
                },
                {
                    name: this.services.sizes['4yd'],
                    slug: '4yd',
                    text: this.$t('jobs.service_description.4yd'),
                    icon: IconSmallSkip,
                },
                {
                    name: this.services.sizes['6yd'],
                    slug: '6yd',
                    text: this.$t('jobs.service_description.6yd'),
                    icon: IconSmallSkip,
                },
                {
                    name: this.services.sizes['8yd'],
                    slug: '8yd',
                    text: this.$t('jobs.service_description.8yd'),
                    icon: IconSmallSkip,
                },
                {
                    name: this.services.sizes['12yd'],
                    slug: '12yd',
                    text: this.$t('jobs.service_description.12yd'),
                    icon: IconSmallSkip,
                },
                {
                    name: this.services.sizes.roll,
                    slug: 'roll',
                    text: this.$t('jobs.service_description.roll'),
                    icon: IconRollerSkip,
                },
            ];
        },
    },
};
